import React from "react";
import * as R from "ramda";
import { countries } from "country-data";
import { Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Option, OptGroup } = Select;

const SelectDD = props => {
  let selected = "";
  const isGrouped = R.isEmpty(props.data);
  const handleChange = value => {
    if (
      props.checkAuthority(value, props.subscriptions, props.dataObj, selected)
    )
      props.onSelect(value);
  };
  const renderGOptions = obj => {
    const keys = Object.keys(obj);
    return keys.map(el => (
      <OptGroup label={el}>{renderOptions(obj[el], `${el}|`)}</OptGroup>
    ));
  };

  const renderOptions = (data, group = "") => {
    return data.map(el => (
      <Option
        disabled={el.disabled ? true : false}
        key={`${group}${el.value}`}
        value={`${props.useGpPrefix ? group : ""}${el.value}`}
      >
        {el.icon && (
          <span role="img" aria-label={el.icon}>
            {countries[el.icon].emoji}{" "}
          </span>
        )}
        {el.value}
      </Option>
    ));
  };
  return (
    <div
      onMouseDown={e => {
        e.preventDefault();
      }}
      style={props.style}
    >
      <Select
        id={props.id}
        name={props.name}
        mode={props.mode}
        defaultValue={props.defaultVal}
        onChange={handleChange}
        maxTagCount={props.maxTagCount}
        disabled={props.disabled}
        value={props.value}
        onSelect={value => {
          selected = value;
        }}
        dropdownRender={menu => (
          <div>
            {menu}
            {props.extraButton && (
              <div
                style={{
                  padding: "15px",
                  cursor: "pointer",
                  textAlign: "center"
                }}
                onClick={props.extraButtonAction}
              >
                <PlusOutlined /> {props.extraButton}
              </div>
            )}
          </div>
        )}
      >
        {isGrouped ? renderGOptions(props.dataObj) : renderOptions(props.data)}
      </Select>
    </div>
  );
};

SelectDD.defaultProps = {
  mode: "default",
  icon: undefined,
  data: [],
  dataObj: {},
  useGpPrefix: false,
  disabled: false,
  checkAuthority: () => true,
  description: undefined
};

export default SelectDD;
